import PaginatedListState from 'flarum/common/states/PaginatedListState';
export default class MentionedByModalState extends PaginatedListState {
  constructor(params, page) {
    if (page === void 0) {
      page = 1;
    }
    const limit = 10;
    params.page = {
      ...(params.page || {}),
      limit
    };
    super(params, page, limit);
  }
  get type() {
    return 'posts';
  }
}
flarum.reg.add('flarum-mentions', 'forum/state/MentionedByModalState', MentionedByModalState);